<template>
  <div class="break-inside-avoid border-primary-200">
    <slot />
  </div>
</template>
